import { useState, useEffect } from 'react';
import homePageService from '../../../services/homePageService';
import './AdminSlider.css';

const ICON_OPTIONS = [
  { value: 'map', label: 'Harita', path: 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z' },
  { value: 'calendar', label: 'Takvim', path: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
  { value: 'document', label: 'Belge', path: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
  { value: 'eye', label: 'Göz', path: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z' },
  { value: 'filter', label: 'Filtre', path: 'M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z' },
  { value: 'share', label: 'Paylaşım', path: 'M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z' },
  { value: 'folder', label: 'Klasör', path: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z' },
  { value: 'search', label: 'Arama', path: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' },
  { value: 'star', label: 'Yıldız', path: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z' },
  { value: 'lightning', label: 'Şimşek', path: 'M13 10V3L4 14h7v7l9-11h-7z' },
  { value: 'globe', label: 'Dünya', path: 'M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
  { value: 'users', label: 'Kullanıcılar', path: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
];

const COLOR_OPTIONS = [
  { value: 'purple', label: 'Mor' },
  { value: 'blue', label: 'Mavi' },
  { value: 'green', label: 'Yeşil' },
  { value: 'red', label: 'Kırmızı' },
  { value: 'yellow', label: 'Sarı' },
  { value: 'indigo', label: 'İndigo' },
  { value: 'pink', label: 'Pembe' },
  { value: 'teal', label: 'Turkuaz' },
];

const AdminFeatures = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editingFeature, setEditingFeature] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newFeature, setNewFeature] = useState({ title: '', description: '', icon: 'star', color: 'blue' });

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const content = await homePageService.getHomePageContent();
      if (content.featuresData) {
        setFeatures(content.featuresData);
      } else {
        // Varsayılan özellikler
        setFeatures([
          { id: 1, title: 'Harita Bütünleşmesi', description: 'Tarihi olayların konumlarını interaktif haritalar üzerinde görüntüleyin', icon: 'map', color: 'purple' },
          { id: 2, title: 'Zaman Çizelgeleri', description: 'Tarihi olayları kronolojik sırayla görüntüleyin', icon: 'calendar', color: 'blue' },
          { id: 3, title: 'Ayrıntılı Bilgiler', description: 'Her olay için kapsamlı bilgi ve kaynaklar', icon: 'document', color: 'green' },
          { id: 4, title: 'Etkileşimli İçerik', description: 'Görseller ve videolarla zenginleştirilmiş içerikler', icon: 'eye', color: 'red' },
          { id: 5, title: 'Özelleştirme', description: 'Kendi zaman çizelgelerinizi oluşturun ve düzenleyin', icon: 'filter', color: 'yellow' },
          { id: 6, title: 'Paylaşım', description: 'Zaman çizelgelerinizi başkalarıyla paylaşın', icon: 'share', color: 'indigo' },
          { id: 7, title: 'Kategoriler', description: 'Olayları kategorilere ayırarak düzenleyin', icon: 'folder', color: 'pink' },
          { id: 8, title: 'Arama', description: 'Tüm zaman çizelgelerinde hızlı arama yapın', icon: 'search', color: 'teal' },
        ]);
      }
    } catch { setError('Veriler yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const save = async (data) => {
    try {
      await homePageService.updateHomePageContent({ featuresData: data });
      setFeatures(data);
      return true;
    } catch { setError('Kaydetme başarısız.'); return false; }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!newFeature.title) { setError('Başlık zorunlu.'); return; }
    const maxId = features.length > 0 ? Math.max(...features.map(f => f.id)) : 0;
    const data = [...features, { ...newFeature, id: maxId + 1 }];
    if (await save(data)) {
      setSuccess('Özellik eklendi.');
      setShowAddForm(false);
      setNewFeature({ title: '', description: '', icon: 'star', color: 'blue' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu özelliği silmek istediğinizden emin misiniz?')) return;
    setError(''); setSuccess('');
    if (await save(features.filter(f => f.id !== id))) setSuccess('Özellik silindi.');
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    const data = features.map(f => f.id === editingFeature.id ? editingFeature : f);
    if (await save(data)) { setSuccess('Özellik güncellendi.'); setEditingFeature(null); }
  };

  const getIconPath = (iconValue) => {
    const icon = ICON_OPTIONS.find(i => i.value === iconValue);
    return icon ? icon.path : ICON_OPTIONS[0].path;
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Özellikler ({features.length})</h3>
          <button className="admin-slider-add-btn" onClick={() => { setShowAddForm(!showAddForm); setEditingFeature(null); }}>+ Yeni Özellik</button>
        </div>

        {showAddForm && (
          <form className="admin-slider-form" onSubmit={handleAdd}>
            <h4>Yeni Özellik Ekle</h4>
            <div className="admin-slider-form-group">
              <label>Başlık</label>
              <input type="text" value={newFeature.title} onChange={(e) => setNewFeature({ ...newFeature, title: e.target.value })} />
            </div>
            <div className="admin-slider-form-group">
              <label>Açıklama</label>
              <textarea value={newFeature.description} onChange={(e) => setNewFeature({ ...newFeature, description: e.target.value })} rows="3" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="admin-slider-form-group">
                <label>İkon</label>
                <select value={newFeature.icon} onChange={(e) => setNewFeature({ ...newFeature, icon: e.target.value })} style={{ width: '100%', padding: '0.5rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff' }}>
                  {ICON_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
              </div>
              <div className="admin-slider-form-group">
                <label>Renk</label>
                <select value={newFeature.color} onChange={(e) => setNewFeature({ ...newFeature, color: e.target.value })} style={{ width: '100%', padding: '0.5rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff' }}>
                  {COLOR_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
              </div>
            </div>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Ekle</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setShowAddForm(false)}>İptal</button>
            </div>
          </form>
        )}

        {editingFeature && (
          <form className="admin-slider-form" onSubmit={handleSaveEdit}>
            <h4>Düzenle: {editingFeature.title}</h4>
            <div className="admin-slider-form-group">
              <label>Başlık</label>
              <input type="text" value={editingFeature.title} onChange={(e) => setEditingFeature({ ...editingFeature, title: e.target.value })} />
            </div>
            <div className="admin-slider-form-group">
              <label>Açıklama</label>
              <textarea value={editingFeature.description} onChange={(e) => setEditingFeature({ ...editingFeature, description: e.target.value })} rows="3" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="admin-slider-form-group">
                <label>İkon</label>
                <select value={editingFeature.icon} onChange={(e) => setEditingFeature({ ...editingFeature, icon: e.target.value })} style={{ width: '100%', padding: '0.5rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff' }}>
                  {ICON_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
              </div>
              <div className="admin-slider-form-group">
                <label>Renk</label>
                <select value={editingFeature.color} onChange={(e) => setEditingFeature({ ...editingFeature, color: e.target.value })} style={{ width: '100%', padding: '0.5rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff' }}>
                  {COLOR_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
              </div>
            </div>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Kaydet</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setEditingFeature(null)}>İptal</button>
            </div>
          </form>
        )}

        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {features.map((feature) => (
            <div key={feature.id} style={{ padding: '1rem', backgroundColor: '#374151', borderRadius: '0.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <div style={{ padding: '0.5rem', backgroundColor: `var(--color-${feature.color}, #374151)`, borderRadius: '0.5rem' }}>
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ width: '1.25rem', height: '1.25rem', color: '#fff' }}>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={getIconPath(feature.icon)} />
                  </svg>
                </div>
                <div>
                  <strong style={{ color: '#f3f4f6', fontSize: '0.9rem' }}>{feature.title}</strong>
                  <p style={{ color: '#9ca3af', fontSize: '0.75rem', margin: '0.25rem 0 0 0' }}>{feature.description}</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button className="admin-slider-btn-edit" onClick={() => { setEditingFeature({ ...feature }); setShowAddForm(false); }}>Düzenle</button>
                <button className="admin-slider-btn-delete" onClick={() => handleDelete(feature.id)}>Sil</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminFeatures;
